import React, { useContext, useEffect, useRef } from "react";
import classNames from "classnames";
import is from "is_js";
import PropTypes from "prop-types";
import { Button, Collapse, Nav, Navbar } from "reactstrap";
import _ from "lodash";
import bgNavbarImg from "../../assets/img/generic/bg-navbar.png";
import { navbarBreakPoint, topNavbarBreakpoint } from "../../config";
import AppContext from "../../context/Context";
import adminRoutesFromMemory from "../../adminRoutes";
import userRoutesFromMemory from "../../userRoutes";
import Flex from "../common/Flex";
import Logo from "./Logo";
import NavbarTopDropDownMenus from "./NavbarTopDropDownMenus";
import NavbarVerticalMenu from "./NavbarVerticalMenu";
import ToggleButton from "./ToggleButton";

const NavbarVertical = ({ navbarStyle }) => {
  let adminRoutes = _.cloneDeep(adminRoutesFromMemory);
  let userRoutes = _.cloneDeep(userRoutesFromMemory);

  const navBarRef = useRef(null);
  const {
    showBurgerMenu,
    isNavbarVerticalCollapsed,
    setIsNavbarVerticalCollapsed,
    isCombo,
    setShowBurgerMenu,
    setNavbarCollapsed,
    loginUserDetails,
  } = useContext(AppContext);

  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  //Control Component did mount and unmounted of hover effect
  if (isNavbarVerticalCollapsed) {
    HTMLClassList.add("navbar-vertical-collapsed");
  }

  //this will filter out the components according to the user roles
  const filterNotAccessibleElement = (defaultRoutes) => {
    let newRoutes = [];

    newRoutes = defaultRoutes.filter((route) => {
      let children = [];
      if (route?.children?.length > 0) {
        children = route.children.filter((child) => {
          return !loginUserDetails.user_not_acccess_list.includes(
            child.controlID
          );
        });
        route.children = children;
      }

      return !loginUserDetails?.user_not_acccess_list?.includes(
        route.controlID
      );
    });

    return newRoutes;
  };

  const filterNotAccessibleElementPartnerSide = (defaultRoutes) => {
    if (loginUserDetails.user_type.toLowerCase() === "user") {
      defaultRoutes = defaultRoutes.filter((route) => {
        return !(
          route.name === "Publish Application" || route.name === "Billing"
        );
      });
    }

    if (
      loginUserDetails.plan_id === "1" ||
      loginUserDetails.plan_id === "3" ||
      loginUserDetails.plan_id === "4" ||
      loginUserDetails.plan_id === "6"
    ) {
      defaultRoutes = defaultRoutes.filter((route) => {
        return route.name !== "Bulk Export";
      });
    }
    return defaultRoutes;
  };

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add("windows");
    }
    if (is.chrome()) {
      HTMLClassList.add("chrome");
    }
    if (is.firefox()) {
      HTMLClassList.add("firefox");
    }
    return () => {
      HTMLClassList.remove("navbar-vertical-collapsed-hover");
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add("navbar-vertical-collapsed-hover");
      }, 100);
    }
  };

  const isExcludesEndpoint = (window.location.href.includes("Chatbox") || window.location.href.includes("apiplusplus"));

  return (
    <>
      {!isExcludesEndpoint  ? (
        <Navbar
          expand={navbarBreakPoint}
          // style={{ zIndex: 2000 }}
          className={classNames("navbar-vertical navbar-glass", {
            [`navbar-${navbarStyle}`]: navbarStyle !== "transparent",
          })}
          light
        >
          <Flex align="center">
            <ToggleButton
              isNavbarVerticalCollapsed={isNavbarVerticalCollapsed}
              setIsNavbarVerticalCollapsed={setIsNavbarVerticalCollapsed}
            />
            <Logo at="navbar-vertical" width={150} height={30} />
          </Flex>

          <Collapse
            navbar
            isOpen={showBurgerMenu}
            className="scrollbar"
            innerRef={navBarRef}
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={() => {
            //   clearTimeout(time);
            //   HTMLClassList.remove("navbar-vertical-collapsed-hover");
            // }}
            style={
              navbarStyle === "vibrant" && {
                backgroundImage: `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbarImg})`,
              }
            }
          >
            <Nav navbar vertical>
              <NavbarVerticalMenu
                routes={
                  loginUserDetails?.is_partner === "0"
                    ? filterNotAccessibleElement(adminRoutes)
                    : filterNotAccessibleElementPartnerSide(userRoutes)
                }
              />
            </Nav>
            <div className="settings px-3 px-xl-0">
              {isCombo && (
                <div className={`d-${topNavbarBreakpoint}-none`}>
                  <div className="navbar-vertical-divider">
                    <hr className="navbar-vertical-hr my-2" />
                  </div>
                  <Nav navbar>
                    <NavbarTopDropDownMenus
                      setNavbarCollapsed={setNavbarCollapsed}
                      setShowBurgerMenu={setShowBurgerMenu}
                    />
                  </Nav>
                </div>
              )}
            </div>
          </Collapse>
        </Navbar>
      ) : (
        <></>
      )}
    </>
  );
};

NavbarVertical.protoTypes = {
  navbarStyle: PropTypes.string,
};

NavbarVertical.defaultProps = {
  navbarStyle: "transparent",
};

export default NavbarVertical;
